import React from "react";


const features = [
  {
    icon: (
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="12" y="8" width="40" height="48" rx="4" fill="#F0F9FF"/>
        <path d="M16 12H48V20H16V12Z" fill="#E0F2FE"/>
        <rect x="28" y="32" width="8" height="8" rx="2" fill="#A1A1AA"/>
        <path d="M18 44H46" stroke="#A1A1AA" strokeWidth="2" strokeLinecap="round"/>
        <path d="M18 38H30" stroke="#A1A1AA" strokeWidth="2" strokeLinecap="round"/>
        <rect x="36" y="14" width="8" height="4" rx="2" fill="#F43F5E"/>
        <rect x="20" y="14" width="8" height="4" rx="2" fill="#3B82F6"/>
      </svg>
    ),
    title: "Visa Services for all E-visa Countries"
  },
  {
    icon: (
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="14" y="10" width="36" height="44" rx="4" fill="#EFF6FF"/>
        <rect x="20" y="16" width="30" height="40" rx="4" fill="#3B82F6"/>
        <circle cx="35" cy="36" r="8" fill="#EFF6FF"/>
        <path d="M35 28V36H43" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M27 28L43 44" stroke="#EFF6FF" strokeWidth="2"/>
        <path d="M27 44L43 28" stroke="#EFF6FF" strokeWidth="2"/>
      </svg>
    ),
    title: "40 years of experience in Visa processing"
  },
  {
    icon: (
      <svg width="64" height="64" viewBox="0] 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32C8 45.2548 18.7452 56 32 56Z" fill="#D1FAE5"/>
        <path d="M32 56C34.3312 56 36.5912 55.6033 38.6853 54.8596C33.5658 52.861 29.5385 47.9372 29.5385 42.1538C29.5385 35.1581 35.1581 29.5385 42.1538 29.5385C45.3846 29.5385 48.3328 30.767 50.4851 32.8131C54.4988 28.5369 56 22.5694 56 16C56 12.6863 53.3137 10 50 10C46.6863 10 44 12.6863 44 16C44 19.3137 46.6863 22 50 22C51.4939 22 52.8837 21.5239 54 20.7188" stroke="#34D399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M24 16C24 19.3137 21.3137 22 18 22C14.6863 22 12 19.3137 12 16C12 12.6863 14.6863 10 18 10C21.3137 10 24 12.6863 24 16Z" fill="#F87171"/>
      </svg>
    ),
    title: "Multi-National Customers"
  },
  {
    icon: (
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M48 24C48 33.9411 32 54 32 54C32 54 16 33.9411 16 24C16 15.1634 23.1634 8 32 8C40.8366 8 48 15.1634 48 24Z" fill="#E0F2FE"/>
        <circle cx="32" cy="24" r="6" fill="#3B82F6"/>
        <path d="M52 44H12V48C12 50.2091 13.7909 52 16 52H48C50.2091 52 52 50.2091 52 48V44Z" fill="#A5B4FC"/>
        <circle cx="32" cy="48" r="2" fill="white"/>
      </svg>
    ),
    title: "End-to-End Visa Assistance"
  },
  {
    icon: (
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M32 8L12 18V32C12 44.4 32 56 32 56C32 56 52 44.4 52 32V18L32 8Z" fill="#D1FAE5"/>
        <path d="M24 32L30 38L42 26" stroke="#10B981" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12 18L32 8L52 18" stroke="#34D399" strokeWidth="2"/>
        <path d="M32 56C32 56 52 44.4 52 32V18" stroke="#34D399" strokeWidth="2"/>
        <path d="M12 18V32C12 44.4 32 56 32 56" stroke="#34D399" strokeWidth="2"/>
      </svg>
    ),
    title: "Documents Safety & Confidentiality"
  },
  {
    icon: (
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="8" y="20" width="48" height="24" rx="4" fill="#3B82F6"/>
        <rect x="16" y="28" width="8" height="8" rx="2" fill="#EFF6FF"/>
        <circle cx="48" cy="16" r="8" fill="#34D399"/>
        <path d="M45 16L47 18L51 14" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    title: "Secure Payment"
  }
];

export function WhyChooseUsAwesome() {
    return (
        <div>
            <div className="text-center mb-10">
                <h2 className="text-3xl font-bold">Why choose us? Because we are Awesome!</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-10 gap-x-8">
                {features.map((feature, index) => (
                    <div key={index} className="text-center flex flex-col items-center">
                        <div className="mb-4">
                            {feature.icon}
                        </div>
                        <h3 className="text-lg font-semibold text-neutral-800">{feature.title}</h3>
                    </div>
                ))}
            </div>
        </div>
    );
}
